export const translations = {
  nl: {
    nav: {
      home: "Home",
      about: "Over Ons",
      products: "Producten",
      contact: "Contact"
    },
    hero: {
      title: "ALPHA PROFILES",
      subtitle: "Innovatie en kwaliteit in elk profiel",
      description: "Duurzame oplossingen voor wand- en plafondsystemen. Uw partner in metalen profielen.",
      cta: "Bekijk Producten",
      contact: "Offerte Aanvragen"
    },
    about: {
      title: "Over Ons",
      subtitle: "Uw betrouwbare partner",
      description: "Alphaprofiles is gespecialiseerd in hoogwaardige metalen profielen, accessoires en gereedschap voor de bouwsector. Met onze expertise en kwaliteitsproducten ondersteunen wij professionals in België en daarbuiten.",
      experience: "Jarenlange Ervaring",
      quality: "Topkwaliteit",
      service: "Snelle Levering"
    },
    products: {
      title: "Onze Producten",
      subtitle: "Ontdek ons assortiment",
      viewAll: "Alle Producten",
      viewDetails: "Bekijk Details",
      categories: "Categorieën",
      allCategories: "Alle Categorieën",
      specifications: "Specificaties",
      noProducts: "Geen producten gevonden",
      backToProducts: "Terug naar Producten"
    },
    contact: {
      title: "Contact",
      subtitle: "Neem contact met ons op",
      address: "Adres",
      phone: "Telefoon",
      email: "E-mail",
      hours: "Openingstijden",
      hoursValue: "Ma - Vr: 07:00 - 16:00",
      closed: "Za - Zo: Gesloten",
      form: {
        name: "Naam",
        email: "E-mail",
        phone: "Telefoon",
        company: "Bedrijf",
        message: "Bericht",
        send: "Verstuur Bericht",
        success: "Bericht verzonden!",
        error: "Er is een fout opgetreden"
      }
    },
    footer: {
      rights: "Alle rechten voorbehouden",
      description: "Uw partner voor metalen profielsystemen."
    },
    admin: {
      stats: {
        products: "Producten",
        categories: "Categorieën",
        messages: "Berichten",
        unread: "Ongelezen"
      }
    },
    common: {
      loading: "Laden...",
      readMore: "Lees Meer"
    }
  },
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      products: "Products",
      contact: "Contact"
    },
    hero: {
      title: "ALPHA PROFILES",
      subtitle: "Innovation and quality in every profile",
      description: "Sustainable solutions for wall and ceiling systems. Your partner in metal profiles.",
      cta: "View Products",
      contact: "Request Quote"
    },
    about: {
      title: "About Us",
      subtitle: "Your reliable partner",
      description: "Alphaprofiles specializes in high-quality metal profiles, accessories and tools for the construction sector. With our expertise and quality products, we support professionals in Belgium and beyond.",
      experience: "Years of Experience",
      quality: "Top Quality",
      service: "Fast Delivery"
    },
    products: {
      title: "Our Products",
      subtitle: "Discover our range",
      viewAll: "All Products",
      viewDetails: "View Details",
      categories: "Categories",
      allCategories: "All Categories",
      specifications: "Specifications",
      noProducts: "No products found",
      backToProducts: "Back to Products"
    },
    contact: {
      title: "Contact",
      subtitle: "Get in touch with us",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Opening Hours",
      hoursValue: "Mon - Fri: 07:00 - 16:00",
      closed: "Sat - Sun: Closed",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        company: "Company",
        message: "Message",
        send: "Send Message",
        success: "Message sent!",
        error: "An error occurred"
      }
    },
    footer: {
      rights: "All rights reserved",
      description: "Your partner for metal profile systems."
    },
    admin: {
      stats: {
        products: "Products",
        categories: "Categories",
        messages: "Messages",
        unread: "Unread"
      }
    },
    common: {
      loading: "Loading...",
      readMore: "Read More"
    }
  },
  fr: {
    nav: {
      home: "Accueil",
      about: "À Propos",
      products: "Produits",
      contact: "Contact"
    },
    hero: {
      title: "ALPHA PROFILES",
      subtitle: "Innovation et qualité dans chaque profil",
      description: "Solutions durables pour les systèmes de murs et plafonds. Votre partenaire en profils métalliques.",
      cta: "Voir les Produits",
      contact: "Demander un Devis"
    },
    about: {
      title: "À Propos",
      subtitle: "Votre partenaire fiable",
      description: "Alphaprofiles est spécialisé dans les profils métalliques de haute qualité, les accessoires et les outils pour le secteur de la construction. Avec notre expertise et nos produits de qualité, nous soutenons les professionnels en Belgique et au-delà.",
      experience: "Années d'Expérience",
      quality: "Qualité Supérieure",
      service: "Livraison Rapide"
    },
    products: {
      title: "Nos Produits",
      subtitle: "Découvrez notre gamme",
      viewAll: "Tous les Produits",
      viewDetails: "Voir les Détails",
      categories: "Catégories",
      allCategories: "Toutes les Catégories",
      specifications: "Spécifications",
      noProducts: "Aucun produit trouvé",
      backToProducts: "Retour aux Produits"
    },
    contact: {
      title: "Contact",
      subtitle: "Contactez-nous",
      address: "Adresse",
      phone: "Téléphone",
      email: "E-mail",
      hours: "Heures d'ouverture",
      hoursValue: "Lun - Ven: 07:00 - 16:00",
      closed: "Sam - Dim: Fermé",
      form: {
        name: "Nom",
        email: "E-mail",
        phone: "Téléphone",
        company: "Entreprise",
        message: "Message",
        send: "Envoyer le Message",
        success: "Message envoyé!",
        error: "Une erreur s'est produite"
      }
    },
    footer: {
      rights: "Tous droits réservés",
      description: "Votre partenaire pour les systèmes de profils métalliques."
    },
    admin: {
      stats: {
        products: "Produits",
        categories: "Catégories",
        messages: "Messages",
        unread: "Non lus"
      }
    },
    common: {
      loading: "Chargement...",
      readMore: "Lire Plus"
    }
  },
  de: {
    nav: {
      home: "Startseite",
      about: "Über Uns",
      products: "Produkte",
      contact: "Kontakt"
    },
    hero: {
      title: "ALPHA PROFILES",
      subtitle: "Innovation und Qualität in jedem Profil",
      description: "Nachhaltige Lösungen für Wand- und Deckensysteme. Ihr Partner für Metallprofile.",
      cta: "Produkte Ansehen",
      contact: "Angebot Anfordern"
    },
    about: {
      title: "Über Uns",
      subtitle: "Ihr zuverlässiger Partner",
      description: "Alphaprofiles ist spezialisiert auf hochwertige Metallprofile, Zubehör und Werkzeuge für die Baubranche. Mit unserer Expertise und Qualitätsprodukten unterstützen wir Fachleute in Belgien und darüber hinaus.",
      experience: "Jahrelange Erfahrung",
      quality: "Höchste Qualität",
      service: "Schnelle Lieferung"
    },
    products: {
      title: "Unsere Produkte",
      subtitle: "Entdecken Sie unser Sortiment",
      viewAll: "Alle Produkte",
      viewDetails: "Details Ansehen",
      categories: "Kategorien",
      allCategories: "Alle Kategorien",
      specifications: "Spezifikationen",
      noProducts: "Keine Produkte gefunden",
      backToProducts: "Zurück zu Produkten"
    },
    contact: {
      title: "Kontakt",
      subtitle: "Nehmen Sie Kontakt mit uns auf",
      address: "Adresse",
      phone: "Telefon",
      email: "E-Mail",
      hours: "Öffnungszeiten",
      hoursValue: "Mo - Fr: 07:00 - 16:00",
      closed: "Sa - So: Geschlossen",
      form: {
        name: "Name",
        email: "E-Mail",
        phone: "Telefon",
        company: "Unternehmen",
        message: "Nachricht",
        send: "Nachricht Senden",
        success: "Nachricht gesendet!",
        error: "Ein Fehler ist aufgetreten"
      }
    },
    footer: {
      rights: "Alle Rechte vorbehalten",
      description: "Ihr Partner für Metallprofilsysteme."
    },
    admin: {
      stats: {
        products: "Produkte",
        categories: "Kategorien",
        messages: "Nachrichten",
        unread: "Ungelesen"
      }
    },
    common: {
      loading: "Laden...",
      readMore: "Mehr Lesen"
    }
  }
};